import React, { ReactNode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

let persistor = persistStore(store);
// const id = localStorage.getItem("bugsnagemail");
// const fname = localStorage.getItem("bugsnagfname");
// const lname = localStorage.getItem("bugsnaglname");
// const email = localStorage.getItem("bugsnagemail");
// const name = `${fname} ${lname}`;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || "",
  plugins: [new BugsnagPluginReact()],
  collectUserIp: false,
});

BugsnagPerformance.start({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || "",
});

// const user = {
//   id: `${id}`,
//   name: `${name}`,
//   email: `${email}`,
// };

// Bugsnag.setUser(user.id, user.email, user.name);

let ErrorBoundary: any = ({ children }: { children: ReactNode }) => (
  <>{children}</>
);
if (Bugsnag) {
  ErrorBoundary = Bugsnag.getPlugin("react")?.createErrorBoundary(React);
}
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export const BugsnagExport = Bugsnag;
